module.exports = __webpack_public_path__ + "img/shangwuhezuo.75c0f06.svg";